<template>
  <div>
    <el-alert
      style="margin-bottom: 15px"
      show-icon
      type="success"
      effect="dark"
      :closable="false"
      title="如果配置了 ldap 并且启用，则会使用 ldap 替代本地用户系统；如果多个 ldap 被启用，那么 jarvis 会使用第一个启用的配置进行登陆等操作；如果不想使用 ldap 则关闭即可"
    ></el-alert>
    <el-row>
      <el-card style="margin: auto;">
        <div slot="header" class="clearfix">
          <span style="float:left; font-weight: 800">LDAP配置列表</span>
          <el-button style="float:right" size="small" type="text" @click="show_add">添加新配置</el-button>
        </div>

        <el-dialog :visible.sync="visible" title="新建LDAP配置" width="30%">
          <el-form ref="ldap" :model="ldap" :rules="rules">
            <el-form-item prop="name" label="名称">
              <el-input v-model="ldap.name" placeholder="请输入名称"></el-input>
            </el-form-item>
            <el-form-item prop="host" label="ldap地址">
              <el-input v-model="ldap.host" placeholder="请输入ldap地址. e.g: 192.168.1.1:389"></el-input>
            </el-form-item>
            <el-form-item prop="baseDN" label="baseDN">
              <el-input v-model="ldap.baseDN" placeholder="请输入baseDN"></el-input>
            </el-form-item>
            <el-form-item prop="user" label="账户">
              <el-input v-model="ldap.user" placeholder="请输入账户地址"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码">
              <el-input v-model="ldap.password" :type="type" placeholder="请输入密码">
                <i slot="suffix" @click="change_type" class="el-icon-view" />
              </el-input>
            </el-form-item>
            <el-form-item prop="enabled" label="是否启用">
              <el-switch style="float:left;margin-top:10px" v-model="ldap.enabled"></el-switch>
            </el-form-item>
          </el-form>
          <template slot="footer">
            <el-button size="small" @click="visible = false">取消</el-button>
            <el-button size="small" @click="create_ldap" type="primary">创建</el-button>
          </template>
        </el-dialog>

        <el-table :data="ldaps" border>
          <el-table-column label="ID" prop="id"></el-table-column>
          <el-table-column label="名称" prop="name"></el-table-column>
          <el-table-column label="ldap地址" prop="host"></el-table-column>
          <el-table-column label="baseDN" prop="baseDN"></el-table-column>
          <el-table-column label="user" prop="user"></el-table-column>
          <el-table-column label="启用">
            <template slot-scope="record">
              <el-tag type="success" size="mini" effect="dark" v-if="record.row.enabled === true">启用</el-tag>
              <el-tag type="danger" effect="dark" size="mini" v-else>停用</el-tag>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="create_at"></el-table-column>
          <el-table-column label="操作" width="180">
            <template slot-scope="scope">
              <el-button type="primary" size="mini" @click="get_ldap(scope.row.id)">编辑</el-button>
              <el-button type="danger" size="mini" @click="delete_ldap(scope.row.id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>

        <el-dialog :visible.sync="edit_visible" :title="'修改' + this.ldap.name + '信息'" width="30%">
          <el-form
            ref="ldap"
            :model="ldap"
            :rules="rules"
          >
            <el-form-item prop="host" label="smtp">
              <el-input v-model="ldap.host" placeholder="请输入ldap地址. e.g: 192.168.1.1:389"></el-input>
            </el-form-item>
            <el-form-item prop="baseDN" label="baseDN">
              <el-input v-model="ldap.baseDN" placeholder="请输入baseDN"></el-input>
            </el-form-item>
            <el-form-item prop="user" label="账户">
              <el-input v-model="ldap.user" placeholder="请输入账户地址"></el-input>
            </el-form-item>
            <el-form-item prop="password" label="密码">
              <el-input v-model="ldap.password" :type="type" placeholder="请输入密码">
                <i slot="suffix" @click="change_type" class="el-icon-view" />
              </el-input>
            </el-form-item>
            <el-form-item prop="enabled" label="是否启用">
              <el-switch v-model="ldap.enabled" />
            </el-form-item>
          </el-form>
          <template slot="footer">
            <el-button size="small" @click="edit_visible = false">取消</el-button>
            <el-button size="small" @click="update_ldap" type="primary">修改</el-button>
          </template>
        </el-dialog>
      </el-card>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      visible: false,
      edit_visible: false,
      ldaps: [],
      type: "password",
      ldap: {
        name: "",
        host: "",
        baseDN: 0,
        user: "",
        password: "",
        enabled: false,
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        host: [{ required: true, message: "请输入ldap地址", trigger: "blur" }],
        user: [{ required: true, message: "请输入账户地址", trigger: "blur" }],
        baseDN: [{ required: true, message: "请输入baseDN", trigger: "blur" }],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }],
      },
    };
  },
  created() {
    this.get_ldaps();
  },
  methods: {
    get_ldaps() {
      const _this = this;
      _this.$axios
        .get(_this.config.path + "/ldaps?currentPage=0&pageSize=20", {
          headers: {
            Authorization: "Bearer " + _this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              showClose: true,
              message: "获取ldap列表失败: " + res.data.message,
              type: "error",
            });
          } else {
            _this.ldaps = res.data.data;
          }
        })
        .catch(function (err) {
          _this.$message({
            showClose: true,
            message: "获取ldap列表失败: " + err.toString(),
            type: "error",
          });
          console.log("get ldaps list error: ", err.toString());
        });
    },
    change_type() {
      if (this.type === "password") {
        this.type = "text";
      } else {
        this.type = "password";
      }
    },
    show_add() {
      this.ldap = {
        name: "",
        host: "",
        baseDN: "",
        user: "",
        password: "",
        enabled: false,
      };
      this.visible = true;
    },
    create_ldap() {
      const _this = this;
      _this.$refs["ldap"].validate((valid) => {
        if (valid) {
          console.log("new ldap: ", _this.ldap);
          _this.$axios
            .post(_this.config.path + "/ldaps", _this.ldap, {
              headers: {
                Authorization: "Bearer " + _this.config.getCookie(),
              },
            })
            .then(function (res) {
              if (res.data.success === false) {
                _this.$message({
                  showClose: true,
                  message: "创建ldap失败: " + res.data.message,
                  type: "error",
                });
              } else {
                _this.$message({
                  showClose: true,
                  message: "创建ldap成功",
                  type: "success",
                });
                setTimeout(() => {
                  _this.$router.go(0);
                }, 300);
              }
            })
            .catch(function (err) {
              _this.$message({
                showClose: true,
                message: "创建ldap失败: " + err.toString(),
                type: "error",
              });
            });
        }
      });
      this.visible = false;
    },
    get_ldap(id) {
      console.log("get ldap info by id:", id);
      const _this = this;
      _this.$axios
        .get(_this.config.path + "/ldaps/" + id, {
          headers: {
            Authorization: "Bearer " + this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === false) {
            _this.$message({
              showClose: true,
              message: "获取ldap信息失败: " + res.data.message,
              type: "error",
            });
          } else {
            _this.ldap = res.data.data;
            console.log("current ldap: ", _this.ldap);
          }
        })
        .catch(function (err) {
          _this.$message({
            showClose: true,
            message: "获取ldap信息失败: " + err.toString(),
            type: "error",
          });
        });
      _this.edit_visible = true;
    },
    update_ldap() {
      console.log("update ldap id: ", this.ldap.id);
      console.log(this.ldap);
      const _this = this;
      _this.$axios
        .put(_this.config.path + "/ldaps/" + _this.ldap.id, _this.ldap, {
          headers: {
            Authorization: "Bearer " + this.config.getCookie(),
          },
        })
        .then(function (res) {
          if (res.data.success === true) {
            _this.$message({
              showClose: true,
              message: "更新成功",
              type: "success",
            });
            setTimeout(function () {
              _this.$router.go(0);
            }, 500);
          } else {
            _this.$message({
              showClose: true,
              message: "更新失败: " + res.data.message,
              type: "error",
            });
          }
        })
        .catch(function (err) {
          _this.$message({
            showClose: true,
            message: "更新失败: " + err.toString(),
            type: "error",
          });
        });
      _this.edit_visible = false;
    },
    delete_ldap(id) {
      console.log("delete ldap id: ", id);
      const _this = this;
      this.$confirm("删除配置后无法还原，确认删除么？", "删除ldap配置", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "error",
      })
        .then(() => {
          _this.$axios
            .delete(_this.config.path + "/ldaps/" + id, {
              headers: {
                Authorization: "Bearer " + _this.config.getCookie(),
              },
            })
            .then(function (res) {
              if (res.data.success === false) {
                _this.$message({
                  showClose: true,
                  message: "删除ldap失败: " + res.data.message,
                  type: "error",
                });
              } else {
                _this.$message({
                  showClose: true,
                  message: "删除ldap成功",
                  type: "success",
                });
                setTimeout(() => {
                  _this.$router.go(0);
                }, 300);
              }
            })
            .catch(function (err) {
              _this.$message({
                showClose: true,
                message: "删除ldap失败: " + err.toString(),
                type: "error",
              });
            });
        })
        .catch(() => {
          _this.$message({
            type: "info",
            message: "已取消删除",
            showClose: true
          });
        });
    },
  },
};
</script>